import axios from "axios";

const push = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/push`, withCredentials: true });

const b64ToU8 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const raw = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const permission = () => ("Notification" in window ? Notification.permission : "unsupported");

async function reg() { return navigator.serviceWorker.ready; }

export async function currentSubscription() { if (!pushSupported()) return null; try { return await (await reg()).pushManager.getSubscription(); } catch { return null; } }

export function deviceLabel() {
  const ua = navigator.userAgent;
  const os = /iphone/i.test(ua) ? "iPhone" : /ipad/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ? "iPad" : /android/i.test(ua) ? "Android" : /windows/i.test(ua) ? "Windows" : /mac/i.test(ua) ? "Mac" : "Appareil";
  const br = /edg/i.test(ua) ? "Edge" : /chrome|crios/i.test(ua) ? "Chrome" : /firefox|fxios/i.test(ua) ? "Firefox" : /safari/i.test(ua) ? "Safari" : "";
  return `${os}${br ? " · " + br : ""}`;
}

/** Demande la permission puis abonne cet appareil ; renvoie le device enregistré côté serveur. */
export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifications push non prises en charge sur ce navigateur. Sur iPhone/iPad, ajoutez d'abord Respondia à l'écran d'accueil.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(perm === "denied" ? "Autorisation refusée. Réactivez les notifications dans les réglages du navigateur ou du téléphone." : "Autorisation non accordée.");
  const { data } = await push.get("/vapid-public-key");
  const r = await reg();
  let sub = await r.pushManager.getSubscription();
  if (!sub) sub = await r.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) });
  const j = sub.toJSON();
  const res = await push.post("/subscribe", { endpoint: j.endpoint, keys: j.keys, label: deviceLabel(), ua: navigator.userAgent.slice(0, 300) });
  return res.data.device;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (sub) { try { await push.post("/unsubscribe", { endpoint: sub.endpoint }); } catch { /* déjà révoqué */ } await sub.unsubscribe(); }
}

/** Si la permission est accordée et qu'un abonnement existe, le re-synchronise (session changée, appareil réinstallé…). */
export async function syncSubscription() {
  if (!pushSupported() || permission() !== "granted") return;
  const sub = await currentSubscription();
  if (!sub) return;
  const j = sub.toJSON();
  try { await push.post("/subscribe", { endpoint: j.endpoint, keys: j.keys, label: deviceLabel(), ua: navigator.userAgent.slice(0, 300) }); } catch { /* non connecté */ }
}

export const listDevices = async () => { const sub = await currentSubscription(); return (await push.get("/devices", { params: { endpoint: sub?.endpoint } })).data; };
export const revokeDevice = (id) => push.delete(`/devices/${id}`);
export const savePrefs = (body) => push.put("/prefs", body).then((r) => r.data);
export const sendTest = (target = "none") => push.post("/test", { target }).then((r) => r.data);
export const pushLog = () => push.get("/log").then((r) => r.data);
